"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-demetrio-ne-vestini": {
    "8538a99d": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "skipSearch": false
    }],
    "cardabello": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8462b162": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "skipSearch": false
    }],
    "cardamone": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9444a238": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "skipSearch": false
    }],
    "collarano": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "02f040a5": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "skipSearch": false
    }],
    "colle": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "19159349": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fefefa34": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "skipSearch": false
    }],
    "villa-grande": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "75c4365f": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "skipSearch": false
    }],
    "ville-cavantoni": [{
      "hkey": "a9cda8a0",
      "slug": "san-demetrio-ne-vestini",
      "name": "San Demetrio ne' Vestini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;